/**
 * MoveProjectModal Messages
 *
 * This contains all the text for the MoveProjectModal component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects.moveProject';

export default defineMessages({
  modalTitle: {
    id: `${scope}.modalTitle`,
    defaultMessage: 'Select Workspace',
  },
  searchTextPlaceholder: {
    id: `${scope}.searchTextPlaceholder`,
    defaultMessage: 'Search',
  },
  moveButtonText: {
    id: `${scope}.moveButtonText`,
    defaultMessage: 'Move',
  },
});
